<script setup lang="ts">
import type { NavLink } from '../model/types';
import HeaderLogo from './logo.vue';

import style from './styles.module.pcss';

defineProps<{
  links: NavLink[];
}>();
</script>

<template>
  <ul class="menu uppercase">
    <header-logo />
    <li
      v-for="(item, index) in links"
      :key="index"
    >
      <nuxt-link
        :to="item.link"
        :class="['flex-c-c', style['menu-item']]"
      >
        {{ item.name }}
      </nuxt-link>
    </li>
  </ul>
</template>

<style scoped lang="postcss">
.menu {
  display: flex;
  align-items: stretch;
  line-height: 1;

  li {
    display: flex;
    align-items: stretch;

    a {
      padding: 0 var(--space-m-var_01, 20px);
    }
  }
}
</style>
